export default "__VITE_ASSET__0dcc6aaa__"